import script from "./AssessmentMotherChild.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentMotherChild.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentMotherChild.vue?vue&type=style&index=0&id=cf840176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf840176"]])

export default __exports__